// User types
export enum USER_STATUS {
  VERIFIED = 'Verified',
  UNVERIFIED = 'UnVerified',
  BLOCKED = 'Blocked',
}

export interface User {
  user_id: number;
  name: string;
  email: string;
  profile_image: string | null;
  phone: string | null;
  status: string;
  last_login_at: string;
  role_id: number;
  role_name: string;
  game_id: string | null;
}

export interface CreateUserRequest {
  email: string;
  name: string;
  phone: string;
  role_id: number;
  game_id?: string;
}

export interface UpdateUserRequest {
  name: string;
  phone: string | null;
  role_id: number;
  status?: string;
  game_id?: string;
}

// Role types
export interface ModulePermission {
  module_name: ModuleName;
  permissions: Permission[];
}

export interface Role {
  role_id: number;
  name: string;
  is_active: boolean;
  module: ModulePermission[];
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface CreateRoleRequest {
  name: string;
  is_active: boolean;
  module: ModulePermission[];
}

export interface UpdateRoleRequest extends CreateRoleRequest {}

// Available permissions
export const AVAILABLE_PERMISSIONS = ['View', 'Add', 'Update'] as const;
export type Permission = (typeof AVAILABLE_PERMISSIONS)[number];

// Available modules
export const AVAILABLE_MODULES = ['dashboard', 'user', 'offer', 'playbook', 'tmc', 'abtesting'] as const;
export type ModuleName = (typeof AVAILABLE_MODULES)[number];

// Module enum for better type safety and easier usage
export enum Module {
  DASHBOARD = 'dashboard',
  USER = 'user',
  OFFER = 'offer',
  PLAYBOOK = 'playbook',
  TMC = 'tmc',
  AB_TESTING = 'abtesting',
}

// Module Permissions Configuration
// Define which permissions are allowed for each module
export const MODULE_PERMISSIONS_CONFIG: Record<ModuleName, readonly Permission[]> = {
  dashboard: ['View'], // Dashboard is read-only
  user: ['View', 'Add', 'Update'], // Full CRUD
  offer: ['View', 'Add', 'Update'], // Full CRUD
  playbook: ['View', 'Add', 'Update'], // Full CRUD
  tmc: ['View', 'Add', 'Update'], // Full CRUD
  abtesting: ['View', 'Add', 'Update'], // Full CRUD
};

// Helper function to get allowed permissions for a module
export const getModulePermissions = (moduleName: ModuleName): readonly Permission[] => {
  return MODULE_PERMISSIONS_CONFIG[moduleName] || AVAILABLE_PERMISSIONS;
};
